// keeps report pins, project flags, photo cards and document pins from covering each other:
// lower-priority icons are nudged aside (margin shift) with a thin leader line to their true point
const SEL = [['.pin-wrap:not(.pp-wrap)', 0], ['.pp-wrap', 1], ['.media-card-wrap', 2], ['.media-pin-wrap', 2], ['.doc-pin-wrap', 3]];
const PAD = 4;
const RINGS = [[0, -1], [1, 0], [-1, 0], [0, 1], [1, -1], [-1, -1], [1, 1], [-1, 1]];

const boxOf = (el) => {
  let r = el.getBoundingClientRect(), b = { l: r.left, t: r.top, r: r.right, b: r.bottom };
  el.querySelectorAll('*').forEach((c) => { const q = c.getBoundingClientRect(); if (q.width && q.height) b = { l: Math.min(b.l, q.left), t: Math.min(b.t, q.top), r: Math.max(b.r, q.right), b: Math.max(b.b, q.bottom) }; });
  return b;
};
const hit = (a, b) => a.l < b.r + PAD && a.r + PAD > b.l && a.t < b.b + PAD && a.b + PAD > b.t;
const move = (b, dx, dy) => ({ l: b.l + dx, r: b.r + dx, t: b.t + dy, b: b.b + dy });

function reset(el) {
  if (el.dataset.dclX == null) return;
  el.style.marginLeft = `${el.dataset.dclMl}px`; el.style.marginTop = `${el.dataset.dclMt}px`;
  delete el.dataset.dclX; el.querySelector(':scope > .dcl-line')?.remove();
}
function shift(el, dx, dy, z) {
  const ml = el.dataset.dclMl ?? (parseFloat(el.style.marginLeft) || 0), mt = el.dataset.dclMt ?? (parseFloat(el.style.marginTop) || 0);
  Object.assign(el.dataset, { dclMl: ml, dclMt: mt, dclX: dx });
  const x = dx / z, y = dy / z;
  el.style.marginLeft = `${+ml + x}px`; el.style.marginTop = `${+mt + y}px`;
  // leader from the icon box centre back to the anchor (local anchor = -margin)
  const ax = -ml - x, ay = -mt - y, cx = el.offsetWidth / 2, cy = el.offsetHeight / 2, len = Math.hypot(ax - cx, ay - cy);
  const ln = el.querySelector(':scope > .dcl-line') || el.appendChild(Object.assign(document.createElement('i'), { className: 'dcl-line' }));
  Object.assign(ln.style, { left: `${cx}px`, top: `${cy}px`, width: `${len}px`, transform: `rotate(${Math.atan2(ay - cy, ax - cx)}rad)` });
}

export function declutter(map, z = 1) {
  const root = map.getContainer();
  const els = SEL.flatMap(([s, p]) => [...root.querySelectorAll(s)].map((el) => ({ el, p })));
  els.forEach(({ el }) => reset(el));
  if (map.getBearing?.()) return;
  const placed = [];
  els.sort((a, b) => a.p - b.p).forEach(({ el, p }) => {
    const b = boxOf(el);
    if (!(b.r - b.l) || p === 0 || !placed.some((q) => hit(b, q))) { placed.push(b); return; }
    // step by the icon itself (labels make the union box very wide)
    const r = el.firstElementChild?.getBoundingClientRect() || el.getBoundingClientRect(), w = Math.min(b.r - b.l, r.width * 1.4) + PAD, h = Math.min(b.b - b.t, r.height * 1.4) + PAD;
    for (const k of [1, 2]) for (const [ux, uy] of RINGS) {
      const dx = ux * w * k * 0.75, dy = uy * h * k * 0.75, n = move(b, dx, dy);
      if (!placed.some((q) => hit(n, q))) { shift(el, dx, dy, z); placed.push(n); return; }
    }
    placed.push(b);
  });
}

export function attachDeclutter(map, zoomOf) {
  let tm = null;
  const run = () => { clearTimeout(tm); tm = setTimeout(() => map.getContainer() && declutter(map, zoomOf()), 150); };
  map.on('zoomend layeradd layerremove rotate', run);
  run();
  return () => { clearTimeout(tm); map.off('zoomend layeradd layerremove rotate', run); };
}
